import React, { Component } from 'react';
import logo from '../assets/images/owl_ci.png';
import app_store from '../assets/images/ico_appstore.png';
import aos_store from '../assets/images/ico_playstore.png';

import './Header.css';

class Header extends Component {
  openAppStore = () => {
    const iosAppLink = 'itms-apps://itunes.apple.com/app/id1582049413';
    const iosWebLink = 'https://apps.apple.com/app/id1582049413';

    window.location.href = iosAppLink;

    setTimeout(() => {
      window.location.href = iosWebLink;
    }, 500);
  };

  openPlayStore = () => {
    const aosAppLink = 'market://details?id=com.lemoncake.mlibrary';
    const aosWebLink = 'https://play.google.com/store/apps/details?id=com.lemoncake.mlibrary';

    window.location.href = aosAppLink;

    setTimeout(() => {
      window.location.href = aosWebLink;
    }, 500);
  };
  
  render() {
    return (
      <div className="App">
        <div className="App-header">
          <div>
            <div className="store">
            <div>
              <img
                className="img"
                src={app_store}
                alt="APPSTORE"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  window.open(
                    'itms-apps://itunes.apple.com/app/id6745247420',
                    '_blank'
                  );
                }}
              />
            </div>

            <div>
              <img
                className="img"
                src={aos_store}
                alt="GOOGLE PLAYSTORE"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  window.open(
                    'https://play.google.com/store/apps/details?id=com.lemoncake.mlibrary',
                    '_blank'
                  );
                }}
              />
            </div>
          </div>
            <p className="content">자정의 도서관</p>
            <p className="subcontent">밤에 나누는 감성 대화</p>
          </div>
          <div style={{margin:"2vmin"}}/>
          <div>
            <img src={logo} className="App-logo" alt="logo" />  
          </div>
        </div>
      </div>
    );
  }
}

export default Header;